export default __webpack_public_path__ + "static/grey-grey-desserto-d0a128f8b8d0626880fc8ce97d6d8304.jpg";